import { type AnyFormApi, useStore } from "@tanstack/react-form";

/** Whether the form's `onDynamic` schema passes, checked without writing errors to any field. */
export function useSchemaValid(form: AnyFormApi): boolean {
  return useStore(form.store, (state) => {
    const schema = form.options.validators?.onDynamic;
    if (!schema || typeof schema !== "object" || !("~standard" in schema)) return true;
    const result = schema["~standard"].validate(state.values);
    return result instanceof Promise || !result.issues;
  });
}
